<template>
  <div class="text-left">
    <div class="row">
      <div class="col-sm-auto">
        <h3 class="font-weight-bolder mt-2">P & I</h3>
      </div>
      <!--            <AddPandI></AddPandI>-->
    </div>
    <div class="row">
      <div class="col-sm-12 text-small text-center">
        <table class="table table-hover table-bordered table-sm">
          <thead class="bg-lightgray">
          <tr>
            <th width="1%">#</th>
            <th>P&I Case No.</th>
            <th>Date</th>
            <th>Vessel</th>
            <th>P&I Club</th>
            <th>Diagnosis</th>
            <!--                        <th>Currency</th>-->
            <!--                        <th>Gross Amt. Claimed</th>-->
            <!--                        <th>Net Amt. Claimed</th>-->
            <th>Days</th>
            <th>Result</th>
            <th>Status</th>
            <th width="1%">File</th>
            <th width="10%">Action</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(pandi, index) in pandis" :key="pandi.id"
              :class="{
                        'bg-lightsilver' : pandi.pandi_result_id === 1,
                        'bg-lightgreen' : pandi.pandi_result_id === 2,
                        'bg-lightred' : pandi.pandi_result_id === 3,
                        }"
              :title="parseUpdateInfo(pandi)"
          >
            <td>{{ index + 1 }}</td>
            <td>{{ pandi.code }}</td>
            <td>{{ pandi.incidentDate }}</td>
            <td>{{ pandi.vessel }}</td>
            <td>{{ pandi.club }}</td>
            <td>{{ pandi.diagnosis }}</td>
            <td>{{ pandi.days }}</td>
            <!--                        <td :title="pandi.currency">{{ pandi.currencySymbol }}</td>-->
            <!--                        <td>{{ pandi.gross_claimed }}</td>-->
            <!--                        <td>{{ pandi.net_claimed }}</td>-->
            <td>{{ pandi.result }}</td>
            <td>{{ pandi.active | status }}</td>
            <td>1</td>
            <td>
              <button class="btn btn-outline-info btn-xs mr-1"
                      data-toggle="modal" data-target="#view-pandi"
                      @click="setPandi(pandi)"
              >
                <i class="fas fa-eye"></i>
                View
              </button>
              <template v-if="(crew.active == 1 || isSystemAdmin) && (isDesignatedPrincipal || isPrincipal || isPrincipalStaff) && !guest && !isKline">
                <button class="btn btn-outline-danger btn-xs"
                        @click="confirmDeletePandi(pandi)"
                >
                  <i class="fas fa-trash"></i>
                  Delete
                </button>
              </template>
            </td>
          </tr>

          </tbody>
        </table>
      </div>
    </div>

    <view-pandi :view-pandi="pandi" :default-values="pandis" @updated-data-from-view-pandi="updatePandiDataFromViewPandiComponent"></view-pandi>

    <!-- View / Edit / Update Modal -->
    <!--        <div class="modal fade" id="viewPandI" tabindex="-1" role="dialog" aria-labelledby="viewPandITitle" aria-hidden="true">-->
    <!--            <div class="modal-dialog modal-dialog-centered modal-xl" role="document">-->
    <!--                <div class="modal-content">-->
    <!--                    <div class="modal-header">-->
    <!--                        <h5 class="modal-title font-weight-bold" id="viewPandITitle">-->
    <!--                            <span v-if="editable">Update</span>-->
    <!--                            P & I Case-->
    <!--                        </h5>-->
    <!--                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"-->
    <!--                                id="close-view-pandi"-->
    <!--                        >-->
    <!--                            <span aria-hidden="true">&times;</span>-->
    <!--                        </button>-->
    <!--                    </div>-->
    <!--                    <div class="small">-->
    <!--                        <div class="modal-body">-->

    <!--                            <div class="row">-->

    <!--                                <div class="col col-sm-5 border-right p-2">-->

    <!--                                    <div class="row">-->
    <!--                                        <div class="col col-sm-12">-->
    <!--                                            <form @submit.prevent="confirmUpdatePandi">-->

    <!--                                                <div class="form-group row mb-1">-->
    <!--                                                    <label for="pni-code" class="col-sm-4 col-form-label font-weight-bold">P&I Case :</label>-->
    <!--                                                    <div class="col-sm-4 pl-0">-->
    <!--                                                        <input type="text" id="pni-code"-->
    <!--                                                               class="form-control form-control-sm"-->
    <!--                                                               placeholder="P&I Case Number"-->
    <!--                                                               :readonly="!editable"-->
    <!--                                                               v-model="pandi.code"-->
    <!--                                                        >-->
    <!--                                                    </div>-->
    <!--                                                    <label for="pni-days" class="col-sm-2 col-form-label px-0 text-right font-weight-bold">Total Days :</label>-->
    <!--                                                    <div class="col-sm-2">-->
    <!--                                                        <input type="text" id="pni-days" readonly-->
    <!--                                                               class="form-control form-control-sm"-->
    <!--                                                               placeholder="0"-->
    <!--                                                               v-model="pandi.days"-->
    <!--                                                        >-->
    <!--                                                    </div>-->
    <!--                                                </div>-->

    <!--                                                <div class="form-group row mb-1">-->
    <!--                                                    <label for="pni-vessel" class="col-sm-4 col-form-label font-weight-bold">Vessel :</label>-->
    <!--                                                    <div class="col-sm-8 pl-0">-->
    <!--                                                        <input type="text" readonly id="pni-vessel" class="form-control form-control-sm"-->
    <!--                                                               :value="pandi.vessel"-->
    <!--                                                        >-->
    <!--                                                    </div>-->
    <!--                                                </div>-->

    <!--                                                <div class="form-group row mb-1">-->
    <!--                                                    <label for="pni-diagnosis" class="col-sm-4 col-form-label font-weight-bold">Diagnosis :</label>-->
    <!--                                                    <div class="col-sm-8 pl-0">-->
    <!--                                        <textarea class="form-control form-control-sm" id="pni-diagnosis" rows="5"-->
    <!--                                                  style="resize: none" readonly-->
    <!--                                                  v-model="pandi.diagnosis"-->
    <!--                                        ></textarea>-->
    <!--                                                    </div>-->
    <!--                                                </div>-->

    <!--                                                <div class="form-group row mb-1">-->
    <!--                                                    <label for="pni-arrival" class="col-sm-4 col-form-label font-weight-bold">Arrival in Manila :</label>-->
    <!--                                                    <div class="col-sm-8 pl-0">-->
    <!--                                                        <input type="text" id="pni-arrival" readonly-->
    <!--                                                               class="form-control form-control-sm"-->
    <!--                                                               placeholder="Arrival Date"-->
    <!--                                                               :value="pandi.arrivalDate"-->
    <!--                                                        >-->
    <!--                                                    </div>-->
    <!--                                                </div>-->

    <!--                                                <div class="form-group row mb-1">-->
    <!--                                                    <label for="pni-endorsement" class="col-sm-4 col-form-label font-weight-bold">Endorsement Date :</label>-->
    <!--                                                    <div class="col-sm-8 pl-0">-->
    <!--                                                        <input type="date" id="pni-endorsement"-->
    <!--                                                               class="form-control form-control-sm"-->
    <!--                                                               :readonly="!editable"-->
    <!--                                                               v-model="pandi.endorsement"-->
    <!--                                                        >-->
    <!--                                                    </div>-->
    <!--                                                </div>-->

    <!--&lt;!&ndash;                                                <div class="form-group row mb-0">&ndash;&gt;-->
    <!--&lt;!&ndash;                                                    <label for="pni-gross" class="col-sm-4 col-form-label font-weight-bold">Gross Claimed :</label>&ndash;&gt;-->
    <!--&lt;!&ndash;                                                    <div class="col-sm-8 pl-0">&ndash;&gt;-->
    <!--&lt;!&ndash;                                                        <input type="number" step=".50" id="pni-gross"&ndash;&gt;-->
    <!--&lt;!&ndash;                                                               class="form-control form-control-sm"&ndash;&gt;-->
    <!--&lt;!&ndash;                                                               :readonly="!editable"&ndash;&gt;-->
    <!--&lt;!&ndash;                                                               v-model="pandi.gross_claimed"&ndash;&gt;-->
    <!--&lt;!&ndash;                                                        >&ndash;&gt;-->
    <!--&lt;!&ndash;                                                    </div>&ndash;&gt;-->
    <!--&lt;!&ndash;                                                </div>&ndash;&gt;-->

    <!--                                                <div class="form-group row mb-1">-->
    <!--                                                    <label for="pni-club" class="col-sm-4 col-form-label font-weight-bolder">P&I Club :</label>-->
    <!--                                                    <div class="col-sm-8 pl-0">-->
    <!--                                                        <select class="custom-select custom-select-sm" id="pni-club"-->
    <!--                                                                v-model="pandi.pandi_club_id"-->
    <!--                                                                :disabled="!editable"-->
    <!--                                                        >-->
    <!--                                                            <option :value="null">-&#45;&#45; SELECT P&I Club -&#45;&#45;</option>-->
    <!--                                                            <option v-for="pandiClubKey in pandiClubKeys"-->
    <!--                                                                    :key="pandiClubKey.id"-->
    <!--                                                                    :value="pandiClubKey.id"-->
    <!--                                                            >{{ pandiClubKey.name }}</option>-->
    <!--                                                        </select>-->
    <!--                                                    </div>-->
    <!--                                                </div>-->

    <!--                                                <div class="form-group row mb-1">-->
    <!--                                                    <label for="pni-result" class="col-sm-4 col-form-label font-weight-bolder">Final Result :</label>-->
    <!--                                                    <div class="col-sm-8 pl-0">-->
    <!--                                                        <select class="custom-select custom-select-sm" id="pni-result"-->
    <!--                                                                v-model="pandi.pandi_result_id"-->
    <!--                                                                :disabled="!editable"-->
    <!--                                                        >-->
    <!--                                                            <option :value="null">-&#45;&#45; SELECT RESULT -&#45;&#45;</option>-->
    <!--                                                            <option v-for="pandiResultKey in pandiResultKeys"-->
    <!--                                                                    :key="pandiResultKey.id"-->
    <!--                                                                    :value="pandiResultKey.id"-->
    <!--                                                            >{{ pandiResultKey.name }}</option>-->
    <!--                                                        </select>-->
    <!--                                                    </div>-->
    <!--                                                </div>-->

    <!--                                                <div class="form-group row mb-1">-->
    <!--                                                    <label for="pni-status" class="col-sm-4 col-form-label font-weight-bold">Status :</label>-->
    <!--                                                    <div class="col-sm-8 pl-0">-->
    <!--                                                        <select class="custom-select custom-select-sm" id="pni-status"-->
    <!--                                                                v-model="pandi.active"-->
    <!--                                                                :disabled="!editable"-->
    <!--                                                        >-->
    <!--                                                            <option :value="1">ACTIVE</option>-->
    <!--                                                            <option :value="0">CLOSED</option>-->
    <!--                                                        </select>-->
    <!--                                                    </div>-->
    <!--                                                </div>-->

    <!--                                                <button type="submit" class="btn btn-outline-danger btn-sm font-weight-bold float-right"-->
    <!--                                                        @click="cancelEdit"-->
    <!--                                                        v-if="editable"-->
    <!--                                                >-->
    <!--                                                    <i class="fas fa-ban"></i>-->
    <!--                                                    Cancel-->
    <!--                                                </button>-->

    <!--                                                <button type="submit" class="btn btn-warning btn-sm font-weight-bold float-right mr-2 mb-2"-->
    <!--                                                        v-if="isDesignatedManning"-->
    <!--                                                >-->
    <!--                                                    <i class="fas fa-edit"></i>-->
    <!--                                                    {{ editable ? 'Update' : 'Edit' }}-->
    <!--                                                </button>-->

    <!--                                            </form>-->
    <!--                                        </div>-->
    <!--                                        <div class="col col-sm-12">-->
    <!--                                            <hr />-->
    <!--                                        </div>-->
    <!--                                        <div class="col col-sm-12">-->
    <!--                                            <form @submit.prevent="confirmAddPandiCheckup">-->
    <!--                                                <div class="form-group row mb-0">-->
    <!--                                                    <label class="col-sm-12 col-form-label font-weight-bold"><u>New Check Up Report :</u></label>-->
    <!--                                                    <label for="new-checkup-date" class="col-sm-4 col-form-label font-weight-bold">Date :</label>-->
    <!--                                                    <div class="col-sm-8 pl-0">-->
    <!--                                                        <input type="date" id="new-checkup-date" required-->
    <!--                                                               class="form-control form-control-sm"-->
    <!--                                                               v-model="newCheckupReport.checkup_date"-->
    <!--                                                        >-->
    <!--                                                    </div>-->
    <!--                                                </div>-->

    <!--                                                <div class="form-group row mb-1">-->
    <!--                                                    <label for="new-checkup-remarks" class="col-sm-4 col-form-label font-weight-bold">Remarks :</label>-->
    <!--                                                    <div class="col-sm-8 pl-0">-->
    <!--                                                <textarea class="form-control form-control-sm" id="new-checkup-remarks" rows="5"-->
    <!--                                                          v-model="newCheckupReport.remarks"-->
    <!--                                                          style="resize: none"></textarea>-->
    <!--                                                    </div>-->
    <!--                                                </div>-->

    <!--                                                <div class="form-group row mb-2">-->
    <!--                                                    <label for="new-checkup-attachment" class="col-sm-4 col-form-label font-weight-bold">Attachment :</label>-->
    <!--                                                    <div class="col-sm-8 pl-0">-->
    <!--                                                        <div class="custom-file" id="new-checkup-attachment-container">-->
    <!--                                                            <input type="file" class="custom-file-input form-control-sm" id="new-checkup-attachment"-->
    <!--                                                                   accept="application/pdf"-->
    <!--                                                                   @change="updateFileLabel('new-checkup-attachment')"-->
    <!--                                                            >-->
    <!--                                                            <label class="custom-file-label text-nowrap" id="new-checkup-attachment-file-label"-->
    <!--                                                                   for="new-checkup-attachment"-->
    <!--                                                            >P & I Report Attachment</label>-->
    <!--                                                        </div>-->
    <!--                                                    </div>-->
    <!--                                                </div>-->

    <!--                                                <div class="row mb-0">-->
    <!--                                                    <div class="col-sm-12 text-right">-->
    <!--                                                        <button type="submit" class="btn btn-outline-success btn-sm border-0">-->
    <!--                                                            <i class="fas fa-plus-circle"></i>-->
    <!--                                                            Add Report-->
    <!--                                                        </button>-->
    <!--                                                    </div>-->
    <!--                                                </div>-->
    <!--                                            </form>-->
    <!--                                        </div>-->
    <!--                                    </div>-->

    <!--                                </div>-->


    <!--                                <div class="col col-sm-7">-->

    <!--                                    <div class="overflow-auto" style="height: 720px;">-->
    <!--                                        <div :key="checkupReport.id"-->
    <!--                                             v-for="(checkupReport, index) in pandi.pandiCheckups"-->
    <!--                                        >-->

    <!--                                            <div class="row mb-0">-->
    <!--                                                <div class="col col-sm-12">-->
    <!--                                                    <label class="col-form-label font-weight-bold"><u>Check Up Report {{ pandi.pandiCheckups.length - index }} :</u></label>-->
    <!--                                                    <button type="submit" class="btn btn-outline-danger btn-sm btn-xs font-weight-bold float-right"-->
    <!--                                                            @click="cancelEditCheckupReport()"-->
    <!--                                                            v-if="checkupReport.id === tempCheckupReport.id"-->
    <!--                                                    >-->
    <!--                                                        <i class="fas fa-ban"></i>-->
    <!--                                                        Cancel-->
    <!--                                                    </button>-->

    <!--                                                    <button class="btn btn-outline-danger btn-sm btn-xs font-weight-bold float-right"-->
    <!--                                                            @click="confirmDeletePandiCheckup(checkupReport)"-->
    <!--                                                            v-else-->
    <!--                                                    >-->
    <!--                                                        <i class="fas fa-trash"></i>-->
    <!--                                                        Delete-->
    <!--                                                    </button>-->

    <!--                                                    <button type="submit" class="btn btn-warning btn-sm btn-xs font-weight-bold float-right mr-2"-->
    <!--                                                            @click="editCheckupReport(checkupReport)"-->
    <!--                                                    >-->
    <!--                                                        <i class="fas fa-edit"></i>-->
    <!--                                                        {{ checkupReport.id === tempCheckupReport.id ? 'Update' : 'Edit' }}-->
    <!--                                                    </button>-->
    <!--                                                </div>-->
    <!--                                            </div>-->

    <!--                                            <div class="form-group row mb-0">-->
    <!--                                                <label :for="'checkup-date-' + checkupReport.id" class="col-sm-4 col-form-label font-weight-bold">Date :</label>-->
    <!--                                                <div class="col-sm-8 pl-0">-->
    <!--                                                    <input type="date" required class="form-control form-control-sm"-->
    <!--                                                           v-if="checkupReport.id === tempCheckupReport.id"-->
    <!--                                                           :id="'checkup-date-' + checkupReport.id"-->
    <!--                                                           v-model="checkupReport.checkup_date"-->
    <!--                                                    >-->
    <!--                                                    <input type="text" class="form-control form-control-sm" readonly-->
    <!--                                                           v-else-->
    <!--                                                           :value="checkupReport.checkup_date | moment('DDMMMY')"-->
    <!--                                                    >-->
    <!--                                                </div>-->
    <!--                                            </div>-->

    <!--                                            <div class="form-group row mb-1">-->
    <!--                                                <label :for="'checkup-remarks-' + checkupReport.id" class="col-sm-4 col-form-label font-weight-bold">Remarks :</label>-->
    <!--                                                <div class="col-sm-8 pl-0">-->
    <!--                                                <textarea class="form-control form-control-sm" :id="'checkup-remarks-' + checkupReport.id" rows="5"-->
    <!--                                                          :readonly="checkupReport.id !== tempCheckupReport.id"-->
    <!--                                                          v-model="checkupReport.remarks"-->
    <!--                                                          style="resize: none"></textarea>-->
    <!--                                                </div>-->
    <!--                                            </div>-->

    <!--                                            <div class="form-group row mb-1">-->
    <!--                                                <label :for="'checkup-attachment-' + checkupReport.id" class="col-sm-4 col-form-label font-weight-bold">Attachment :</label>-->
    <!--                                                <div class="col-sm-8 pl-0">-->

    <!--                                                    <input type="file" class="form-control-sm"-->
    <!--                                                           accept="application/pdf"-->
    <!--                                                           v-if="checkupReport.id === tempCheckupReport.id"-->
    <!--                                                           :id="'checkup-attachment-' + checkupReport.id"-->
    <!--                                                    >-->

    <!--                                                    <a href="#" class="font-weight-bold card-link"-->
    <!--                                                       v-else-->
    <!--                                                       @click="viewCheckupReport(index, checkupReport.id)"-->
    <!--                                                    >View Checkup Report Attachment {{ pandi.pandiCheckups.length - index }}</a>-->
    <!--                                                </div>-->
    <!--                                            </div>-->
    <!--                                            <hr />-->

    <!--                                        </div>-->

    <!--                                    </div>-->
    <!--                                </div>-->
    <!--                            </div>-->


    <!--                        </div>-->
    <!--                        <div class="modal-footer">-->
    <!--                            <button type="button" class="btn btn-secondary btn-sm mx-1" data-dismiss="modal">-->
    <!--                                <i class="fas fa-times"></i>-->
    <!--                                Close-->
    <!--                            </button>-->

    <!--                        </div>-->
    <!--                    </div>-->
    <!--                </div>-->
    <!--            </div>-->
    <!--        </div>-->

  </div>
</template>

<script>
// import AddPandI from '@/components/sub_components/master_lists/crews/crew_show_components/medical_issues/add/AddPandI';
import {vueAppMixin} from "@/mixins/vueAppMixin";
import {formMixin} from "@/mixins/formMixin";
import {dataMixin} from "@/mixins/dataMixin";
import {gateMixin} from "@/mixins/gateMixin";
import {mapActions, mapGetters} from 'vuex';

import ViewPandi from "./ViewPandi";

export default {
  name: "PandI",
  mixins: [vueAppMixin, formMixin, dataMixin, gateMixin],
  components: {ViewPandi},
  data() {
    return {
      pandi: {},
      pandiErrors: {},
      origPandi: {},
      defaultPandi: [],
      editable: false,
      newCheckupReport: {},
      newCheckupReportErrors: {},
      tempCheckupReport: {},
      pandiCheckupErrors: {},
      checkupReportOrig: {},
      checkupReportFile: ''
    }
  },

  methods: {
    ...mapActions([
      'getPandis',
      'getPandiResultKeys',
      'updatePandi',
      'getPandiClubKeys',
      'addPandiCheckup',
      'getCheckupReportFile',
      'updatePandiCheckup',
      'undoEditPandiCheckup',
      'deletePandiCheckup',
      'deletePandi',
      'getPandiCheckups'
    ]),

    async initializeData() {
      let params = {
        crewId: this.crew.id
      };
      await this.getPandis(params);
      await this.getPandiResultKeys();
      await this.getPandiClubKeys();
    },

    setPandi(pandi) {
      this.pandi = Object.assign({}, pandi);
      this.origPandi = Object.assign({}, pandi);
      this.editable = false;
      this.getPandiCheckups({pandiId: pandi.id});
      this.defaultPandi.push(this.pandi);
      // console.log(this.defaultPandi, 'pandis');
    },

    cancelEdit() {
      this.pandi = Object.assign({}, this.origPandi);
      this.editable = false;
    },

    async confirmUpdatePandi() {
      if (this.editable) {
        if (await this.confirmUpdate()) {
          let params = {
            id: this.pandi.id,
            code: this.pandi.code,
            endorsement: this.pandi.endorsement,
            pandi_result_id: this.pandi.pandi_result_id,
            pandi_club_id: this.pandi.pandi_club_id,
            active: this.pandi.active
          };
          let updatedPandi = await this.updatePandi(params);
          if (updatedPandi) {
            if (updatedPandi.errors) {
              this.pandiErrors = updatedPandi.errors;
            } else {
              this.successAlert('P&I Successful  ly Updated', 'UPDATE');
              document.getElementById('close-view-pandi').click();
              this.editable = false;
            }
          } else {
            this.errorAlert('P&I Failed to Update', 'UPDATE');
          }
        }
      } else {
        this.editable = true;
      }
    },

    async confirmAddPandiCheckup() {
      if (await this.confirmCreateAlert()) {
        let formData = new FormData();
        formData.append('pandi_id', this.pandi.id);
        formData.append('checkup_date', this.newCheckupReport.checkup_date);
        formData.append('remarks', this.newCheckupReport.remarks);
        let fileInput = document.getElementById('new-checkup-attachment');
        let files = fileInput.files;
        if (files.length && files[0]) {
          formData.append('pandiCheckupAttachment', files[0]);
        }
        let newPandiCheckup = await this.addPandiCheckup(formData);
        if (newPandiCheckup) {
          if (newPandiCheckup.errors) {
            this.newCheckupReportErrors = newPandiCheckup.errors;
          } else {
            this.newCheckupReport = {};
            this.newCheckupReportErrors = {};
            this.successAlert('P&I Checkup Successfully UPLOAD', 'UPLOAD');
            this.refreshInputFile('new-checkup-attachment-container')
          }
        } else {
          this.errorAlert('P&I Checkup Failed to UPLOAD', 'UPLOAD');
        }
      }
    },

    updateFileLabel(labelIdentifier) {
      let fileInput = document.getElementById(labelIdentifier);
      let labelId = labelIdentifier + '-file-label';
      let fileLabel = document.getElementById(labelId);
      let labelText = 'Choose File';
      if (fileInput.files && fileInput.files.length) {
        let fileList = [];
        fileInput.files.forEach(file => fileList.push(file.name))
        labelText = fileList.join(', ');
      }
      fileLabel.innerHTML = labelText;
    },

    async viewCheckupReport(index, checkupReportId) {
      this.checkupReportFile = '';
      let params = {
        checkupReportId: checkupReportId
      };
      let checkupReportFile = await this.getCheckupReportFile(params);
      if (checkupReportFile) this.checkupReportFile = `data:application/pdf;base64,${checkupReportFile}`;
      await this.pdfViewer(`Checkup Report ${index + 1}`, this.checkupReportFile);
    },

    async editCheckupReport(checkupReport) {
      if (this.tempCheckupReport && checkupReport.id === this.tempCheckupReport.id) {
        if (await this.confirmUpdate()) {
          let formData = new FormData();
          formData.append('pandiCheckupId', checkupReport.id);
          formData.append('checkup_date', checkupReport.checkup_date);
          formData.append('remarks', checkupReport.remarks);
          let fileInput = document.getElementById('checkup-attachment-' + checkupReport.id);
          let files = fileInput.files;
          if (files.length && files[0]) {
            formData.append('pandiCheckupAttachment', files[0]);
          }
          let updatedPandiCheckup = await this.updatePandiCheckup(formData);

          if (updatedPandiCheckup !== false) {
            if (updatedPandiCheckup.errors) {
              this.pandiCheckupErrors = updatedPandiCheckup.errors;
            } else {
              this.successAlert('P&I Checkup Successfully UPDATED', 'UPDATE');
              this.tempCheckupReport = {};
              this.pandi.days = updatedPandiCheckup;
              this.origPandi.days = updatedPandiCheckup;
            }
          } else {
            this.errorAlert('P&I Checkup Failed to UPDATE', 'UPDATE');
          }
        }
      } else {
        this.tempCheckupReport = Object.assign({}, checkupReport);
      }
    },

    cancelEditCheckupReport() {
      this.undoEditPandiCheckup(this.tempCheckupReport);
      this.tempCheckupReport = {};
    },

    async confirmDeletePandiCheckup(pandiCheckup) {
      if (await this.confirmDeleteAlert()) {
        let params = {
          id: pandiCheckup.id,
          pandi_id: pandiCheckup.pandi_id
        };
        let deletedPandiCheckup = await this.deletePandiCheckup(params);
        if (deletedPandiCheckup) {
          if (!deletedPandiCheckup.errors) {
            this.successAlert('P&I Checkup Successfully DELETED', 'DELETE');
            this.pandi.days = deletedPandiCheckup;
            this.origPandi.days = deletedPandiCheckup;
          }
        } else {
          this.errorAlert('P&I Checkup Failed to DELETE', 'DELETE');
        }
      }
    },

    async confirmDeletePandi(pandi) {
      if (await this.confirmDeleteAlert()) {
        let params = {
          id: pandi.id
        };
        let deletedPandi = await this.deletePandi(params);
        if (deletedPandi) {
          if (!deletedPandi.errors) {
            this.successAlert('P&I Successfully DELETED', 'DELETE');
          }
        } else {
          this.errorAlert('P&I Failed to DELETE', 'DELETE');
        }
      }
    },


    parseUpdateInfo(pandi) {
      let updateInfo = '';

      if (pandi.createdBy) updateInfo += `Created By: ${pandi.createdBy} at ${pandi.createdAt}`;
      if (pandi.updatedBy) updateInfo += `\nUpdated By: ${pandi.updatedBy} at ${pandi.updatedAt}`;

      return updateInfo;
    },

    updatePandiDataFromViewPandiComponent(updatedPandiData){
      this.pandi = updatedPandiData;
    }

  },

  computed: {
    ...mapGetters(['crew', 'pandis', 'pandiResultKeys', 'pandiClubKeys'])
  },

  created() {
    this.initializeData();
  }

}
</script>

<style scoped>
.bg-lightgray {
  background: lightgray;
}

table td {
  vertical-align: middle;
}
</style>
